/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var People1MinusIcon16Regular = forwardRef('People1MinusIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.502 4.498a3.498 3.498 0 1 1 6.996 0 3.498 3.498 0 0 1-6.996 0ZM8 2.5a1.998 1.998 0 1 0 0 3.996A1.998 1.998 0 0 0 8 2.5Z" }),
        React.createElement("path", { d: "M3.93 11.765c-.251.339-.43.808-.43 1.488a.75.75 0 0 1-1.5 0c0-.964.26-1.754.723-2.38.457-.618 1.074-1.025 1.709-1.294C5.678 9.052 7.125 9.003 8 9.003a.75.75 0 0 1 0 1.5c-.86 0-2.039.058-2.983.458-.46.195-.831.457-1.088.804Z" }),
        React.createElement("path", { d: "M9.75 11.25a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Z" })));
});
